import { render, staticRenderFns } from "./SvgFileInput.vue?vue&type=template&id=27e44451&scoped=true"
import script from "./SvgFileInput.vue?vue&type=script&lang=js"
export * from "./SvgFileInput.vue?vue&type=script&lang=js"
import style0 from "./SvgFileInput.vue?vue&type=style&index=0&id=27e44451&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e44451",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e44451')) {
      api.createRecord('27e44451', component.options)
    } else {
      api.reload('27e44451', component.options)
    }
    module.hot.accept("./SvgFileInput.vue?vue&type=template&id=27e44451&scoped=true", function () {
      api.rerender('27e44451', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SvgFileInput.vue"
export default component.exports